import { Ref } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { TrainingStepRawData } from "./TrainingStepRawData";
import { TrainingStepState } from "./TrainingStepState";


export class TrainingStepData extends StepData
{
    public PlannedTime = new Ref<Date>(new Date(0));
    public DoneTime = new Ref<Date>(new Date(0));
    public CancelationReason = new Ref<string>("");

    constructor(raw: Partial<TrainingStepRawData>)
    {
        super(raw);

        this.State.value ||= TrainingStepState.NotPlannedYet;

        this.PlannedTime.value = this.GetDate(raw.PlannedTime);
        this.CancelationReason.value = this.GetString(raw.CancelationReason);
        this.DoneTime.value = this.GetDate(raw.DoneTime);
    }
}
